module.exports = __webpack_public_path__ + "img/delete.f51c6921.svg";